import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { loadingConfig, shimmerPlaceholderConfig } from './PlanLoading.Config';
import styles from './PlanLoading.Styles';

const PlanLoading = ({ withPercentageView, withUsers, hideProgressBars }) => {
  const theme = useTheme();

  return (
    <View style={styles.cardContainerStyle(theme)}>
      <Shimmer
        config={loadingConfig(withPercentageView, withUsers, hideProgressBars, theme)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    </View>
  );
};

PlanLoading.defaultProps = {
  withPercentageView: true,
  withUsers: true,
  hideProgressBars: false,
};

PlanLoading.propTypes = {
  withPercentageView: PropTypes.bool,
  withUsers: PropTypes.bool,
  hideProgressBars: PropTypes.bool,
};

export default PlanLoading;
